export default __webpack_public_path__ + "static/media/panierPlus.5c362caa.svg";